import { motionValue } from "framer-motion";

/*
 * Shared audio amplitude motion value (0..1).
 * Written by MiniPlayer's Web Audio analyser every frame.
 * Read by ScrollWords so committed words breathe with Krishna's voice
 * while a narration plays. Zero when no audio is playing.
 */
export const audioAmplitude = motionValue(0);
